import { ReactNode } from 'react';
import classnames from 'classnames';

import style from './LeftTitle.module.scss';
import '@components/mixins/commonStyles.scss';

export enum LeftTitleModifiers {
    // @ts-ignore
    WithoutTopPadding = style.withoutTop,
    // @ts-ignore
    SmallGap = style.smallGap,
}

export interface LeftTitleProps {
    title: string;
    light?: boolean;
    modifiers?: LeftTitleModifiers[];
    customTitleWidth?: number;
    customTitleTop?: number;
    children: ReactNode;
}

interface Props extends LeftTitleProps {}

export function LeftTitle({ title, light, customTitleWidth, customTitleTop, children, modifiers }: Props) {
    return (
        <div
            className={classnames([
                style.root,
                'font_label',
                modifiers && [...modifiers],
                !!customTitleWidth && style.root_customTitleWidth,
                (light || !!customTitleWidth) && style.root_light,
            ])}
        >
            <div
                className={style.title}
                style={
                    !!customTitleWidth || !!customTitleTop
                        ? {
                              width: `${customTitleWidth}px`,
                              top: `${customTitleTop}px`,
                          }
                        : {}
                }
            >
                {title}
            </div>
            {children}
        </div>
    );
}
